import React, { useContext, useEffect, useCallback } from "react";
import { MyContext } from "../../../context/MyContext";
import { Close } from "../../../assets/svgs/icons";

const URLS = {
  LOGIN: `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}/tutor`,
  NEW_JOIN: process.env.REACT_APP_JOIN_URL,
};

const LoginModal = () => {
  const { user, setUser, setIsLogin, referrerUrl } = useContext(MyContext);

  // 외부 클릭 시 모달 닫기
  const handleBackdropClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        setIsLogin(false);
      }
    },
    [setIsLogin],
  );

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsLogin(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [setIsLogin]);

  useEffect(() => {
    localStorage.removeItem("userInfo");
    setUser((prev) => ({
      ...prev,
      id: null,
      tone: null,
      picture_extension: null,
      picture_data: null,
      name: null,
      paid: false,
      start_dt: null,
      end_dt: null,
      tutor_cnt: 0,
      socra_cnt: 0,
    }));
  }, []);

  const handleLogin = () => {
    setIsLogin(false);
    if (referrerUrl) {
      const loginUrl = `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${referrerUrl}`;
      window.location.assign(loginUrl);
    } else {
      window.location.assign(URLS.LOGIN);
    }
  };

  const handleJoin = () => {
    setIsLogin(false);
    window.location.assign(URLS.NEW_JOIN);
  };

  return (
    // 배경 오버레이 - 클릭 시 모달 닫힘
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50"
      onClick={handleBackdropClick}
    >
      {/* 모달 컨테이너 */}
      <div className="relative flex flex-col gap-10 items-center bg-white rounded-[20px] pt-10 pb-4 px-4 w-[328px] shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)]">
        {/* 닫기 버튼 */}
        <button
          className="absolute top-0 right-0 p-3"
          onClick={() => setIsLogin(false)}
          aria-label="닫기"
        >
          <Close className="w-6 h-6" style={{ fill: "#b2b2b2" }} />
        </button>

        {/* 로고 + 텍스트 */}
        <div className="flex flex-col gap-4 items-center w-full">
          {/* 로고 */}
          <div className="py-4">
            <img
              src="https://img.dongascience.com/air/icon_logo.svg"
              alt="과학동아AiR"
              className="w-32 h-8"
            />
          </div>

          {/* 안내 텍스트 */}
          <p className="text-sm font-medium text-[#212121] text-center tracking-[-0.28px] leading-5">
            로그인 후 과학동아AiR를
            <br />
            이용해보세요!
          </p>
        </div>

        {/* 버튼 영역 */}
        <div className="flex flex-col gap-4 w-full">
          {/* 로그인 버튼 */}
          <button
            onClick={handleLogin}
            className="w-full h-12 rounded-[24px] bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa] hover:from-[#ab38a6] hover:via-[#4927b9] hover:to-[#2b78cf] text-white font-bold text-base tracking-[-0.32px] transition-all duration-200"
          >
            로그인
          </button>

          {/* 회원가입 링크 */}
          <div className="flex items-center gap-4 border-t border-[#eee] border-solid w-full">
            <span className="flex-1 text-xs text-[#888] tracking-[-0.24px] leading-4">
              과학동아AiR가 처음이신가요?
            </span>
            <button
              onClick={handleJoin}
              className="h-8 flex items-center justify-center text-sm font-bold text-[#888] tracking-[-0.28px] underline"
            >
              회원가입
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
